require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./premier-tech-academy.json") })
        }
      }, "path---premier-tech-academy");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---premier-tech-academy!./.cache/json/premier-tech-academy.json
// module id = 1221
// module chunks = 231608221292675